import { render, staticRenderFns } from "./NovaSenhaLinkExpirado.vue?vue&type=template&id=34f79655"
import script from "./NovaSenhaLinkExpirado.vue?vue&type=script&lang=js"
export * from "./NovaSenhaLinkExpirado.vue?vue&type=script&lang=js"
import style0 from "./NovaSenhaLinkExpirado.vue?vue&type=style&index=0&id=34f79655&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports